import request from '../utils/request-axios'
import api from '../utils/api'

//公司认证分页
export function getAttestationPage(params) {
  return request(`${api.getAttestationPage}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//公司认证详情
export function getAttestationDetails(params) {

  return request(`${api.getAttestationDetails}${params}`, {
    loading: true,
    method: 'get',
  });
}

//公司认证同意
export function getAttestationStart(params) {
  return request(`${api.getAttestationStart}${params}`, {
    loading: true,
    method: 'put',
  });
}

//公司认证驳回
export function getAttestationOut(params) {
  return request(`${api.getAttestationOut}${params}`, {
    loading: true,
    method: 'put',
  });
}


//组织认证分页
export function getOrgPage(params) {
  return request(`${api.getOrgPage}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//组织认证详情
export function orgDetails(params) {
  return request(`${api.orgDetails}${params}`, {
    loading: true,
    method: 'get',
  });
}

//组织认证同意
export function agreeOrg(params) {
  return request(`${api.agreeOrg}${params}`, {
    loading: true,
    method: 'get',
  });
}

//组织认证驳回
export function refuseOrg(params) {
  return request(`${api.refuseOrg}${params}`, {
    loading: true,
    method: 'post',
  });
}




// WEBPACK FOOTER //
// ./src/services/attestation.js